module.exports = __webpack_public_path__ + "assets/img/p_item_6.f68950f8.png";